import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { GregorianDatePickerComponent } from '../components/gregorian-date-picker.component';
import {NgbDatepickerModule} from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [
    GregorianDatePickerComponent,
 
  ],
  imports:[
    CommonModule,
    FormsModule ,
    NgbDatepickerModule

  ],
  exports:[
    GregorianDatePickerComponent,
    NgbDatepickerModule
  ]
})
export class GregorianDatePickerModule { }
